<template>
  <v-container
    fill-height
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        xs="12"
        sm="6"
        md="4"
        lg="3"
        xl="2"
      >
        <v-alert
          v-if="error"
          color="error"
          outlined
          class="alert-login-failed"
        >
          {{ error }}
        </v-alert>

        <v-card class="elevation-12 pa-3">
          <v-form
            ref="form_redefinir_senha"
            @submit="redefinirSenha"
            v-on:submit.prevent="() => false"
          >
            <v-card-text class="text-center">
              <img
                src="../assets/logo-empresta.svg"
                class="logo-empresta"
                alt="Empresta Bem Melhor"
                title="Empresta Bem Melhor"
              >
              <div>
                <h6 class="title font-weight-regular">Redefinição de senha:</h6>
              </div>
            </v-card-text>

            <v-card-text class="pl-0 pr-0">
              <v-text-field
                v-model="senha_atual"
                name="senha_atual"
                id="senha_atual"
                label="Senha atual"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                @click:append="showPassword = !showPassword"
                :rules="[v => !!v || 'Senha atual é obrigatório']"
                required
                class="mb-2"
                autocomplete="off"
                outlined
              ></v-text-field>

              <v-row class="ml-3">Requisitos de senha:</v-row>
              <v-row
                align="center"
                justify="space-between"
                class="mb-2"
              >
                <v-col
                  align-self="center"
                  class="text-center"
                >
                  <v-chip
                    v-bind:class="{ success: senha_valida.minuscula }"
                    label
                    x-small
                  >
                    Minúscula
                  </v-chip>
                </v-col>

                <v-col
                  align-self="center"
                  class="text-center"
                >
                  <v-chip
                    v-bind:class="{ success: senha_valida.numero }"
                    label
                    x-small
                  >
                    Número
                  </v-chip>
                </v-col>

                <v-col
                  align-self="center"
                  class="text-center"
                >
                  <v-chip
                    v-bind:class="{ success: senha_valida.maiuscula }"
                    label
                    x-small
                  >
                    Maiúscula
                  </v-chip>
                </v-col>

                <v-col
                  align-self="center"
                  class="text-center"
                >
                  <v-chip
                    v-bind:class="{ success: senha_valida.minimo }"
                    label
                    x-small
                  >
                    Mínimo 8 caracteres
                  </v-chip>
                </v-col>
                <v-col
                  align-self="center"
                  class="text-center"
                >
                  <v-chip
                    v-bind:class="{ success: senha_valida.senhaIguais }"
                    label
                    x-small
                  >
                    Confirmação de senha
                  </v-chip>
                </v-col>
              </v-row>
              <v-text-field
                v-model="nova_senha"
                hide-details="auto"
                name="nova_senha"
                id="nova_senha"
                label="Nova senha"
                :rules="[
                  v => !!v || 'Nova senha é obrigatório',
                ]"
                required
                :type="showPassword ? 'text' : 'password'"
                @keyup="validacaoSenha"
                maxlength="20"
                counter="20"
                autocomplete="off"
                outlined
              ></v-text-field>
              <v-text-field
                v-model="confirmacao_nova_senha"
                hide-details="auto"
                name="confirmacao_nova_senha"
                id="confirmacao_nova_senha"
                label="Confirmação nova Senha"
                data-vv-validate-on="change|blur|input"
                :rules="[
                  v => !!v || 'Confirmação nova da senha é obrigatório',
                  v => senhasIguais || 'Confirmação da senha e Nova Senha são diferentes',
                  v => minimoCaractere || 'A senha deve possuir no mínimo 8 caracteres'
                ]"
                required
                :type="showPassword ? 'text' : 'password'"
                @keyup="validacaoSenha"
                maxlength="20"
                counter="20"
                autocomplete="off"
                outlined
              ></v-text-field>
            </v-card-text>

            <v-card-actions class="pl-0 pr-0">
              <v-btn
                block
                large
                color="success"
                type="submit"
              >Redefinir senha</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <Loading :exibir="loading" />
  </v-container>
</template>

<script>
import Loading from '../components/Loading'

export default {
  name: 'AlterarSenha',
  components: {
    Loading
  },
  data: () => ({
    senha_atual: '',
    nova_senha: '',
    confirmacao_nova_senha: '',
    senha_valida: {
      minuscula: false,
      numero: false,
      maiuscula: false,
      minimo: false,
      senhaIguais: false,
    },
    showPassword: false,
    error: false,
    loading: false
  }),
  methods: {
    async validarToken() {
      this.loading = true
      const token = localStorage.getItem('token')

      if (!token) {
        this.removerLocalStorage()
        return this.$router.push({ name: 'login' })
      }

      return await this.axios.get('validar-token', {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(() => {
          this.loading = false
          return true
        })
        .catch(() => {
          this.removerLocalStorage()
          return this.$router.push({ name: 'login' })
        })
    },
    validacaoSenha() {
      this.senha_valida.minuscula = /[a-z]/.test(this.nova_senha)
      this.senha_valida.numero = /\d/.test(this.nova_senha)
      this.senha_valida.maiuscula = /[A-Z]/.test(this.nova_senha)
      this.senha_valida.minimo = (this.nova_senha && this.nova_senha.length > 7) && (this.confirmacao_nova_senha && this.confirmacao_nova_senha.length > 7)
      this.senha_valida.senhaIguais = this.nova_senha == this.confirmacao_nova_senha
    },
    async redefinirSenha() {
      const token = this.getStorage('token')
      const valido = await this.$refs.form_redefinir_senha.validate()
      const senhaValida = Object.values(this.senha_valida).includes(false)

      if (!valido || senhaValida || !this.senhasIguais) {
        return false
      }

      this.loading = true
      this.axios.post('usuario/alterar-senha', {
        old_password: this.senha_atual,
        password: this.nova_senha
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(response => {
        const { data } = response.data
        if (data.status) {
          localStorage.removeItem('redefinir_senha')
          return this.irParaIntranet()
        }
        this.error = data.mensagem
        this.loading = false
      }).catch((err) => {
        let { data } = err.response
        data = data.data || data

        this.error = data.mensagem || 'Erro de comunicação com servidor!'
        this.loading = false
      })
    },
    removerLocalStorage() {
      localStorage.removeItem('token')
      localStorage.removeItem('redirect')
      localStorage.removeItem('redefinir_senha')
    },
    irParaIntranet() {
      const token = this.getStorage('token')
      let redirect = this.getStorage('redirect')

      if (token && redirect) {
        redirect = `${redirect}?token=${token}`
        window.location.href = redirect
        return true
      }

      this.removerLocalStorage()
      return this.$router.push({ name: 'login' })
    },
    getStorage(key) {
      return localStorage.getItem(key)
    },
  },
  async created() {
    this.loading = true
    await this.validarToken()
  },
  computed: {
    senhasIguais: function () {
      return this.nova_senha == this.confirmacao_nova_senha
    },
    minimoCaractere: function () {
      return (this.nova_senha && this.nova_senha.length > 7) && (this.confirmacao_nova_senha && this.confirmacao_nova_senha.length > 7) && (this.nova_senha == this.confirmacao_nova_senha)
    }
  }
}
</script>

<style scoped lang="scss">
.logo-empresta {
  height: 65px;
  margin-bottom: 10px;
}
</style>
